// extracted by mini-css-extract-plugin
export default {"contact-form":"ContactForm_contact-form__yUAd0","error":"ContactForm_error__5V4Z7","success":"ContactForm_success__MVX1y","sending":"ContactForm_sending__PJBo9"};